
import React, { PureComponent } from 'react';

import { translate } from '../../../base/i18n';
import { Icon, IconInfo } from '../../../base/icons';
import { Switch } from '../../../base/react';
import { connect } from '../../../base/redux';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { toggleFocusMode } from '../../actions.any';
import { isFocusModeEnabled, isFocusModeToggleVisible } from '../../functions';

type Props = {

    /**
     * Whether Focus Mode is currently on.
     */
    _enabled: boolean,

    /**
     * Whether the toggle should be offered to this user at all.
     */
    _visible: boolean,

    /**
     * The redux dispatch function.
     */
    dispatch: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Lets a host turn Focus Mode on for the meeting. Rendered next to the lobby
 * toggle in the participants pane and the security dialog.
 */
class FocusModeSection extends PureComponent<Props> {
    /**
     * Instantiates a new {@code FocusModeSection}.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);

        this._onToggle = this._onToggle.bind(this);
    }

    /**
     * Implements {@code PureComponent#render}.
     *
     * @inheritdoc
     */
    render() {
        const { _enabled, _visible, t } = this.props;

        if (!_visible) {
            return null;
        }

        return (
            <div id = 'focus-mode-section'>
                <div className = 'control-row'>
                    <div className = 'lobby-section-child lobby-section-child-pane'>
                        <label htmlFor = 'focus-mode-section-switch'>
                            { t('focusMode.dialogTitle') }
                        </label>
                        <Tooltip
                            content = { t('focusMode.enableDialogText') }
                            position = 'bottom-left'>
                            <Icon
                                size = { 20 }
                                src = { IconInfo } />
                        </Tooltip>
                    </div>
                    <div className = 'lobby-section-child lobby-section-child-pane'>
                        <Switch
                            id = 'focus-mode-section-switch'
                            onValueChange = { this._onToggle }
                            value = { _enabled } />
                    </div>
                </div>
            </div>
        );
    }

    _onToggle: () => void;

    /**
     * Flips Focus Mode for the meeting.
     *
     * @private
     * @returns {void}
     */
    _onToggle() {
        this.props.dispatch(toggleFocusMode(!this.props._enabled));
    }
}

/**
 * Maps (parts of) the redux state to the associated props.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state: Object): $Shape<Props> {
    return {
        _enabled: isFocusModeEnabled(state),
        _visible: isFocusModeToggleVisible(state)
    };
}

export default translate(connect(mapStateToProps)(FocusModeSection));
